export const isBrowser = typeof window !== 'undefined'

export const isEDMode = isBrowser && window.location.href.indexOf("ed=1") > -1

export const checkEdParams = (item) => {
    return isEDMode && window.location.search.indexOf(item) > -1
}